import { VIEWED_STEP } from './';
import { EventTypes } from 'redux-segment';

export default function trackStepView({ step }) {
  if (!step) {
    console.warn('No step provided for step view');
  }

  return {
    type: VIEWED_STEP,
    step,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: VIEWED_STEP,
          properties: {
            step,
          },
        },
      },
    },
  };
}
